'use client';

import React from 'react';

export default function AIHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 overflow-hidden">
      {/* Ambient violet glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 70% 80% at 50% 30%, rgba(124,58,237,0.18) 0%, transparent 60%)',
        }}
      />
      {/* Dot grid */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.07]"
        style={{
          backgroundImage:
            'radial-gradient(rgba(167,139,250,0.6) 1px, transparent 1px)',
          backgroundSize: '36px 36px',
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto text-center">
        {/* Kicker badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[rgba(124,58,237,0.3)] mb-8 reveal-blur">
          <span className="w-1.5 h-1.5 rounded-full bg-[#A78BFA] status-pulse" />
          <span className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase">
            AI Roadmap · 2026 · Teaser
          </span>
        </div>

        {/* Headline */}
        <h1
          className="font-manrope font-extrabold tracking-tighter leading-[0.95] reveal-blur"
          style={{ fontSize: 'clamp(2.5rem, 7vw, 6rem)' }}
        >
          <span className="text-light-scan">AI-native</span>
          <br />
          <span className="text-[#EEEEF0]">real estate,</span>
          <br />
          <span
            style={{
              background: 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 60%, #EEEEF0 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            from day one.
          </span>
        </h1>

        {/* Lead */}
        <p className="mt-8 text-lg md:text-xl text-[#9999A8] max-w-3xl mx-auto leading-relaxed reveal-blur">
          The industry is shifting from <span className="text-[#EEEEF0] font-semibold">task automation</span> to{' '}
          <span className="text-[#A78BFA] font-semibold">outcome automation</span>. Propmatic is an agentic
          operating system for property management — where every workflow runs itself by default, and humans
          step in only for judgment calls.
        </p>

        {/* Quick stat strip */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 stagger-children">
          {[
            { k: '21% → 34%', v: 'AI adoption among PMs (24→25)' },
            { k: '10+ h/wk', v: 'Saved per user (early adopters)' },
            { k: '72%', v: 'Owners investing in AI solutions' },
            { k: '81%', v: 'Rank data/tech as #1 spend' },
          ].map((s) => (
            <div
              key={s.k}
              className="reveal-blur bento-card p-5 text-left"
            >
              <div
                className="font-manrope font-extrabold text-2xl md:text-3xl tracking-tight"
                style={{
                  background: 'linear-gradient(135deg, #A78BFA, #7C3AED)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {s.k}
              </div>
              <div className="text-[11px] font-mono text-[#9999A8] mt-1 leading-snug">{s.v}</div>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4 reveal-blur">
          <a
            href="#modules"
            className="cta-primary inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm tracking-tight shadow-violet-glow-lg"
          >
            Explore the 6 AI modules
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 5v14M5 12l7 7 7-7" />
            </svg>
          </a>
          <a
            href="#roadmap"
            className="cta-secondary inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm"
          >
            See the 9-month roadmap
          </a>
        </div>
      </div>
    </section>
  );
}
